import { Box, Typography } from '@mui/material';
import Section from 'components/shared/Section';
import { formatDealAmount } from 'helper/short-currency';
import { useAppSelector } from 'store/hooks';
import zeplinColor, { PricingIntelligenceBarColors } from 'theme/Color';
import { Utilities } from 'utilities/utilities';
import LinearProgressBarWithDot from './LinearProgressBarWithDot';

const PricingIntelligence = () => {
  const { totalCeilingRate, totalTargetPrice, totalFloorRate, pricingHealth, zone } =
    useAppSelector((state) => state.pricingIntelligenceAndServices);

  return (
    <Section title='Pricing Intelligence'>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: '10px',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            color: zeplinColor.Neutral8,
          }}
        >
          <Typography variant='responsiveHeading5'>{formatDealAmount(totalFloorRate)}</Typography>
          <Typography variant='responsiveHeading5'>{formatDealAmount(totalCeilingRate)}</Typography>
        </Box>

        <LinearProgressBarWithDot
          value={pricingHealth}
          color={PricingIntelligenceBarColors[zone]}
        />
      </Box>

      <Box sx={{ display: 'inline-flex', alignItems: 'baseline', gap: '4px' }}>
        <Typography variant='responsiveBody3'>Current:</Typography>
        <Typography variant='responsiveHeading5'>{formatDealAmount(totalTargetPrice)}</Typography>
        <Typography variant='responsiveHeading5' sx={{ color: PricingIntelligenceBarColors[zone] }}>
          ({Utilities.capitalize(zone)} Zone)
        </Typography>
      </Box>
    </Section>
  );
};

export default PricingIntelligence;
